interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
}

export const Info = ({ width = 19, height = 19, hexColor = "#FF0101", }: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.5" cy="9.5" r="9" stroke={hexColor} />
            <path d="M9 4.71777C9 4.29297 9.29297 4 9.71777 4C10.1426 4 10.4502 4.29297 10.4502 4.71777C10.4502 5.14258 10.1426 5.44287 9.71777 5.44287C9.29297 5.44287 9 5.14258 9 4.71777ZM9.13916 7.07617H10.3037V14.1074H9.13916V7.07617Z" fill={hexColor} />
        </svg>
    );
};

export default Info;
